import React from 'react';
import styled, { css } from 'styled-components';
import Image from './image';
import Name from './name';
import JobTitle from './job-title';
import Email from './email';
import Tel from './tel';
import Department from './department';
import '../../fragments/employee-preview';

const Preview = ({
  className,
  image,
  name,
  jobTitle,
  department,
  email,
  tel,
  telWithCountryCode,
}) => (
  <div className={className}>
    <div>
      <Image
        image={image}
      />
    </div>
    <div>
      <Name>{name}</Name>
      <JobTitle>{jobTitle}</JobTitle>
      {department && (
        <Department>{department}</Department>
      )}
      <Email email={email} />
      <Tel tel={tel} telWithCountryCode={telWithCountryCode} />
    </div>
  </div>
);

export default styled(Preview)`
  color: ${({ theme }) => theme.grayColor};
  font-weight: 400;
  padding-bottom: ${(props) => props.theme.grid.columnGap};

  ${({ image }) => Boolean(image) && css`
    display: grid;
    grid-auto-rows: auto;
    grid-gap: ${(props) => props.theme.grid.columnGap};
    grid-template-columns: 1fr;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      grid-template-columns: 1fr 1fr;
    }
  `}

  a {
    display: block;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.primaryColor};
  }
`;
